export interface Package {
  id: string;
  name: string;
  customerName: string;
  customerId: string;
  service: string;
  totalSessions: number;
  remainingSessions: number;
  startDate: string;
  endDate: string;
  giftKeseKopuk: boolean;
  giftKeseKopukUsed: boolean;
  renewReminder: boolean;
  active: boolean;
  price: number;
  lastSessionDate: string;
}

export const packages: Package[] = [
  {
    id: "pkg-001",
    name: "10 Seans Klasik Masaj Paketi",
    customerName: "Ayşe Yılmaz",
    customerId: "cus-001",
    service: "Klasik Masaj (60 dk)",
    totalSessions: 10,
    remainingSessions: 4,
    startDate: "2025-12-01",
    endDate: "2026-06-01",
    giftKeseKopuk: true,
    giftKeseKopukUsed: true,
    renewReminder: false,
    active: true,
    price: 6500,
    lastSessionDate: "2026-05-01",
  },
  {
    id: "pkg-002",
    name: "20 Seans VIP Spa Paketi",
    customerName: "Mehmet Demir",
    customerId: "cus-002",
    service: "SPA Günü Paketi",
    totalSessions: 20,
    remainingSessions: 7,
    startDate: "2025-08-15",
    endDate: "2026-08-15",
    giftKeseKopuk: true,
    giftKeseKopukUsed: false,
    renewReminder: false,
    active: true,
    price: 42000,
    lastSessionDate: "2026-05-04",
  },
  {
    id: "pkg-003",
    name: "6 Seans Anti-Aging Paketi",
    customerName: "Zeynep Arslan",
    customerId: "cus-005",
    service: "Anti-Aging Cilt Bakımı",
    totalSessions: 6,
    remainingSessions: 2,
    startDate: "2026-01-10",
    endDate: "2026-07-10",
    giftKeseKopuk: true,
    giftKeseKopukUsed: true,
    renewReminder: true,
    active: true,
    price: 7200,
    lastSessionDate: "2026-05-02",
  },
  {
    id: "pkg-004",
    name: "12 Seans Medikal Masaj",
    customerName: "Nur Aydın",
    customerId: "cus-009",
    service: "Medikal Masaj",
    totalSessions: 12,
    remainingSessions: 3,
    startDate: "2026-02-01",
    endDate: "2026-08-01",
    giftKeseKopuk: false,
    giftKeseKopukUsed: false,
    renewReminder: false,
    active: true,
    price: 9600,
    lastSessionDate: "2026-04-22",
  },
  {
    id: "pkg-005",
    name: "8 Seans Aromaterapi",
    customerName: "Deniz Kara",
    customerId: "cus-011",
    service: "Aromaterapi Masajı",
    totalSessions: 8,
    remainingSessions: 5,
    startDate: "2026-03-01",
    endDate: "2026-09-01",
    giftKeseKopuk: true,
    giftKeseKopukUsed: true,
    renewReminder: false,
    active: true,
    price: 6800,
    lastSessionDate: "2026-05-05",
  },
  {
    id: "pkg-006",
    name: "5 Seans Cilt + Masaj",
    customerName: "Selin Çelik",
    customerId: "cus-007",
    service: "Cilt Bakımı + Masaj Paketi",
    totalSessions: 5,
    remainingSessions: 1,
    startDate: "2026-04-01",
    endDate: "2026-06-01",
    giftKeseKopuk: true,
    giftKeseKopukUsed: true,
    renewReminder: true,
    active: true,
    price: 8200,
    lastSessionDate: "2026-05-03",
  },
  {
    id: "pkg-007",
    name: "10 Seans Sporcu Masajı",
    customerName: "Ahmet Koç",
    customerId: "cus-008",
    service: "Sporcu Masajı",
    totalSessions: 10,
    remainingSessions: 8,
    startDate: "2026-04-15",
    endDate: "2026-10-15",
    giftKeseKopuk: false,
    giftKeseKopukUsed: false,
    renewReminder: false,
    active: true,
    price: 7500,
    lastSessionDate: "2026-04-28",
  },
  {
    id: "pkg-008",
    name: "4 Seans Detoks SPA",
    customerName: "Ece Yıldız",
    customerId: "cus-010",
    service: "Detoks SPA Paketi",
    totalSessions: 4,
    remainingSessions: 0,
    startDate: "2026-02-01",
    endDate: "2026-04-01",
    giftKeseKopuk: true,
    giftKeseKopukUsed: false,
    renewReminder: true,
    active: true,
    price: 8000,
    lastSessionDate: "2026-03-15",
  },
  {
    id: "pkg-009",
    name: "15 Seans VIP Wellness",
    customerName: "Can Özdemir",
    customerId: "cus-006",
    service: "SPA Günü Paketi",
    totalSessions: 15,
    remainingSessions: 0,
    startDate: "2025-10-01",
    endDate: "2026-04-01",
    giftKeseKopuk: true,
    giftKeseKopukUsed: true,
    renewReminder: true,
    active: false,
    price: 32000,
    lastSessionDate: "2026-04-10",
  },
  {
    id: "pkg-010",
    name: "6 Seans Tuz Odası",
    customerName: "Burak Şahin",
    customerId: "cus-004",
    service: "Tuz Odası (Haloterapi)",
    totalSessions: 6,
    remainingSessions: 4,
    startDate: "2026-04-20",
    endDate: "2026-07-20",
    giftKeseKopuk: false,
    giftKeseKopukUsed: false,
    renewReminder: false,
    active: true,
    price: 2500,
    lastSessionDate: "2026-05-06",
  },
];